var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative h-vh-100" },
    [
      _c("van-search", {
        staticClass: "fixed width-99 z-99",
        attrs: {
          clearable: "",
          shape: "round",
          "show-action": "",
          placeholder: "请输入客户名称查询",
        },
        on: { search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center",
                    on: { click: _vm.onSearch },
                  },
                  [_vm._v("搜索")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.queryData.customerCompanyName,
          callback: function ($$v) {
            _vm.$set(_vm.queryData, "customerCompanyName", $$v)
          },
          expression: "queryData.customerCompanyName",
        },
      }),
      _c("div", { staticClass: "h-110" }),
      _c(
        "div",
        {
          staticClass:
            "zjm-fixed-bottom pos-b-140 pos-r-20 bg-FFDB43 cor-00 font-50",
          on: { click: _vm.onAddClick },
        },
        [_vm._v("+")]
      ),
      _c(
        "div",
        {
          staticClass:
            "zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28",
          on: { click: _vm.goBack },
        },
        [_vm._v("返回")]
      ),
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshLoading,
            callback: function ($$v) {
              _vm.refreshLoading = $$v
            },
            expression: "refreshLoading",
          },
        },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.pageFinished,
                "finished-text": " - 没有更多了 - ",
              },
              on: { load: _vm.onLoad },
              model: {
                value: _vm.pageLoading,
                callback: function ($$v) {
                  _vm.pageLoading = $$v
                },
                expression: "pageLoading",
              },
            },
            _vm._l(_vm.messageList, function (item) {
              return _c(
                "van-row",
                {
                  key: item.id,
                  staticClass: "task-block border-8 m-10 p-5 bg-FF",
                  attrs: { align: "center" },
                  on: {
                    click: function ($event) {
                      return _vm.detail(item.id)
                    },
                  },
                },
                [
                  _c(
                    "van-col",
                    { staticClass: "p-20 m-t-10", attrs: { span: "24" } },
                    [
                      _c(
                        "van-row",
                        {
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c(
                            "van-col",
                            { attrs: { span: "3" } },
                            [
                              _c("van-icon", {
                                staticClass: "p-t-20",
                                attrs: {
                                  size: "30",
                                  name: "friends",
                                  color: "#FFDA3E",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("van-col", { attrs: { span: "19" } }, [
                            _c("div", { staticClass: "sender-info" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "cor-33 font-30 font-weight-600",
                                },
                                [_vm._v(_vm._s(item.customerCompanyName))]
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访人"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28" }, [
                              _vm._v(_vm._s(item.customerUserName)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访时间"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28" }, [
                              _vm._v(_vm._s(item.visitTime)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "van-row",
                        {
                          staticClass: "m-t-1",
                          attrs: {
                            type: "flex",
                            align: "top",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "6" } }, [
                            _c("span", { staticClass: "cor-88 font-28" }, [
                              _vm._v("拜访记录"),
                            ]),
                          ]),
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "cor-33 font-28 hjj" }, [
                              _vm._v(_vm._s(item.visitGoal)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("van-divider", { staticClass: "divider-small" }),
                      _c(
                        "van-row",
                        {
                          attrs: {
                            type: "flex",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c("van-col", { attrs: { span: "18" } }, [
                            _c("span", { staticClass: "font-28 cor-00" }, [
                              _vm._v("记录："),
                            ]),
                            _c("span", { staticClass: "font-28 cor-00" }, [
                              _vm._v(
                                _vm._s(item.createByName) +
                                  " " +
                                  _vm._s(_vm.convertTime(item.createTime))
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }